import CommercialDashboardAPI from '../../api/commercialDashboard';

const state = {
  overview: null,
  error: null,
  uiFlags: {
    isFetchingOverview: false,
  },
};

const getters = {
  getOverview: $state => $state.overview,
  getUIFlags: $state => $state.uiFlags,
  getError: $state => $state.error,
};

const mutations = {
  SET_OVERVIEW($state, data) {
    $state.overview = data;
  },
  SET_ERROR($state, error) {
    $state.error = error;
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

const actions = {
  async fetchOverview({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetchingOverview: true });
    commit('SET_ERROR', null);
    try {
      const { data } = await CommercialDashboardAPI.overview(params);
      commit('SET_OVERVIEW', data);
      return data;
    } catch (error) {
      commit('SET_ERROR', error?.response?.data?.message || error.message);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetchingOverview: false });
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
